module.exports = __webpack_public_path__ + "img/exporter_Toutes_Familles.faef884d.png";